import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDocusignComponent } from './simple-icons-docusign.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDocusignComponent ],
    exports:      [ SimpleIconsDocusignComponent ],
    bootstrap:    []
})
export class SimpleIconsDocusignModule {}
